import { FormArray, FormControl, FormGroup } from '@angular/forms';

import { FormInputEvent } from '../models/form-input-event.model';

export class FormHelper {
	/**
	 * Marks all form controls in form group as dirty, to highlight validation.
	 *
	 * @param {FormGroup} form
	 */
	static forceValidate(form: FormGroup | FormArray, requiresValue = false): void {
		Object.keys(form.controls).forEach((key) => {
			if (form.controls[key] instanceof FormControl && (!requiresValue || form.controls[key].value) && form.controls[key].invalid) {
				form.controls[key].markAsDirty();
			} else if (form.controls[key] instanceof FormGroup || form.controls[key] instanceof FormArray) {
				this.forceValidate(form.controls[key], requiresValue);
			}
		});
	}

	/**
	 * Cleans up all form controls inside form group.
	 *
	 * @param {FormGroup} form
	 */
	static reset(form: FormGroup): void {
		Object.keys(form.controls).forEach((key) => {
			form.controls[key].markAsPristine();
			form.controls[key].markAsUntouched();
		});
	}

	/**
	 * Creates FormInputEvent from form object.
	 */
	static getInputEvent(form: any): FormInputEvent {
		let node_name: string = form.target.nodeName.toLowerCase();

		if (node_name === 'input') {
			node_name += '[type=' + form.target.type + ']';
		}

		return new FormInputEvent(form.target.form.name, node_name, form.target.name);
	}

	/**
	 * Gets field names of all invalid controls on form.
	 */
	static getInvalidControls(form: FormGroup | FormArray): string[] {
		const invalid = [];

		Object.keys(form.controls).filter((key: string) => {
			if (form.controls[key] instanceof FormControl && form.controls[key].invalid) {
				invalid.push(key);
			} else if (form.controls[key] instanceof FormGroup || form.controls[key] instanceof FormArray) {
				this.getInvalidControls(form.controls[key]).forEach((value) => {
					invalid.push(key + '_' + value);
				});
			}

			return form.controls[key].invalid;
		});

		return invalid;
	}

	/**
	 * Gets field names of all completed controls on form.
	 */
	static getCompletedControls(form: FormGroup): string[] {
		return Object.keys(form.controls).filter((key: string) => {
			return (
				form.controls[key].value !== '' &&
				form.controls[key].value !== null &&
				form.controls[key].value !== false
			);
		});
	}

	/**
	 * Gets field names of all empty controls on form.
	 */
	static getEmptyControls(form: FormGroup): string[] {
		return Object.keys(form.controls).filter((key: string) => {
			return (
				form.controls[key].value === '' ||
				form.controls[key].value === null ||
				form.controls[key].value === false
			);
		});
	}
}
